"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EmptyBodyGraphqlError = void 0;
var _axios = require("@ori/axios");
var _GraphqlError = require("./GraphqlError");
/**
 * Error that indicates that fetch to graphql server was successful, but had empty response
 */
class EmptyBodyGraphqlError extends _GraphqlError.GraphqlError {
  constructor(response) {
    const message = 'Empty body returned from GraphQl server';
    // eslint-disable-next-line unicorn/custom-error-definition -- okay in this case
    super(new _axios.AxiosError(message, _axios.AxiosError.ERR_BAD_RESPONSE, response.config, response.request, response));
    this.name = 'EmptyBodyGraphqlError';
    this.message = message;
  }
}
exports.EmptyBodyGraphqlError = EmptyBodyGraphqlError;
